import { put, takeLatest } from "@redux-saga/core/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { createSearchParams } from "react-router-dom";
import { call, select } from "redux-saga/effects";
import { AppState } from "../../../store";
import fetchAPI, { ApiResponse } from "../../../utils/api";
import bookingPageSlice from "../../booking-page/store/slice";
import userSlice, { Role, RoleCode, User } from "./slice";

export type UserRequestParams = {
  search?: string;
  roleCode?: RoleCode;
  companyId?: number;
  onlyWithCompanies: boolean;
};

type UserResponse = ApiResponse<{ data: User[] }>;

function* userSaga() {
  yield takeLatest(userSlice.actions.fetch, handleFetch);
  yield takeLatest(bookingPageSlice.actions.setIsFiltersOpened, handleReset);
}

function* handleFetch({
  payload: { search, roleCode, companyId, onlyWithCompanies },
}: PayloadAction<UserRequestParams>) {
  const role: Role | undefined = yield select((state: AppState) =>
    state.roles.data.find((role) => role.code === roleCode)
  );

  const params = createSearchParams({
    search: search || "",
    role_id: role ? role.id.toString() : "",
    only_with_companies: onlyWithCompanies ? "1" : "0",
    company_id: companyId ? companyId.toString() : "",
  }).toString();

  const response: UserResponse = yield call(fetchAPI, `/users?${params}`);

  if (response.data) {
    yield put(userSlice.actions.setData(response.data));
  }

  yield put(userSlice.actions.setIsLoading(false));
}

function* handleReset({ payload: isOpened }: PayloadAction<boolean>) {
  if (!isOpened) {
    yield put(userSlice.actions.reset());
  }
}

export default userSaga;
